export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=jp.co.carelink.worker";

/** App Store（iOS） */
export const APP_STORE_URL =
  "https://apps.apple.com/jp/app/%E3%82%B1%E3%82%A2%E3%83%AA%E3%83%B3%E3%82%AF-%E4%BB%8B%E8%AD%B7-%E7%A6%8F%E7%A5%89%E5%8D%98%E7%99%BA%E3%83%90%E3%82%A4%E3%83%88-%E3%82%B9%E3%83%9D%E3%83%83%E3%83%88%E3%83%AF%E3%83%BC%E3%82%AF/id6762252640";

/** LIFF（LINE） */
export const LIFF_ID = process.env.NEXT_PUBLIC_LIFF_ID ?? "";

/** Deep Link（App Store / Play Store） */
export const APP_SCHEME_URL =
  process.env.NEXT_PUBLIC_APP_SCHEME_URL ?? "carelinkworker://open";

export const APP_SCHEME = APP_SCHEME_URL.split("://")[0];

export const APP_PACKAGE_ID =
  process.env.NEXT_PUBLIC_APP_PACKAGE_ID ?? "jp.co.carelink.worker";